
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --sic-promo-cutout--bg-image:'';
  --cutout-left-offset:var(
    --sic-promo-cutout--left-offset,
    var(--sic-promo-cutout--default--left-offset)
  );

  display:block;
  border-radius:var(--sic-promo-cutout--default--border-radius);
  border-radius:var(
    --sic-promo-cutout--border-radius,
    var(--sic-promo-cutout--default--border-radius)
  );
  --sic-body-text--font-size:var(--sic-promo-cutout--default--text-size);
  --sic-body-text--line-height:var(
    --sic-promo-cutout--default--text-line-height
  );
}

.promo-cutout-wrapper{
  padding-top:var(--sic-promo-cutout--default--top-offset--mobile);
  padding-top:var(
    --sic-promo-cutout--top-offset--mobile,
    var(--sic-promo-cutout--default--top-offset--mobile)
  );
}

.promo-cutout-layout-wrapper{
  display:grid;
  grid-template-columns:repeat(2, 50%);
  grid-template-rows:1fr;
  grid-column-gap:0px;
  grid-row-gap:0px;

  border-radius:var(--sic-promo-cutout--default--border-radius);

  border-radius:var(
    --sic-promo-cutout--border-radius,
    var(--sic-promo-cutout--default--border-radius)
  );
  overflow:hidden;
}

.layout-area-content{
  align-self:center;
}

.layout-area-media{
  position:relative;
}

.layout-content-wrapper{
  aspect-ratio:10/7;
  display:flex;
  align-items:center;
  padding-right:var(--cutout-left-offset);
  width:100%;
}

.content{
  padding:var(--sic-promo-cutout--default--content-padding);
  padding:var(
    --sic-promo-cutout--content-padding,
    var(--sic-promo-cutout--default--content-padding)
  );
}

.body{
  font-size:var(--sic-promo-cutout--default--text-size);
  font-size:var(
    --sic-promo-cutout--text-size,
    var(--sic-promo-cutout--default--text-size)
  );
  line-height:var(--sic-promo-cutout--default--text-line-height);
  line-height:var(
    --sic-promo-cutout--text-line-height,
    var(--sic-promo-cutout--default--text-line-height)
  );
  padding-top:var(--sic-promo-cutout--default--text-spacing);
  padding-top:var(
    --sic-promo-cutout--text-spacing,
    var(--sic-promo-cutout--default--text-spacing)
  );
}

.body p{
    margin:0 0 var(--sic-promo-cutout--default--text-size);
    margin:0 0 var(
        --sic-promo-cutout--text-size,
        var(--sic-promo-cutout--default--text-size)
      );
  }

.body p:last-child{
      margin-bottom:0;
    }

.cta{
  padding-top:var(--sic-promo-cutout--default--cta-spacing);
  padding-top:var(
    --sic-promo-cutout--cta-spacing,
    var(--sic-promo-cutout--default--cta-spacing)
  );
}

.cutout-bg{
  background-color:var(--sic-promo-cutout--default--media-bg-color);
  background-color:var(
    --sic-promo-cutout--media-bg-color,
    var(--sic-promo-cutout--default--media-bg-color)
  );

  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  z-index:0;
}

.cutout-bg .cutout-bg-image{
    background-image:var(--sic-promo-cutout--bg-image);
    background-position:center;
    background-repeat:no-repeat;
    background-size:cover;

    position:absolute;
    top:0;
    left:0;
    right:0;
    bottom:0;
  }

.cutout-bg .cutout-bg-image-blur{
    -webkit-backdrop-filter:var(--sic-promo-cutout--default--media-bg-blur);
            backdrop-filter:var(--sic-promo-cutout--default--media-bg-blur);
    -webkit-backdrop-filter:var(
      --sic-promo-cutout--media-bg-blur,
      var(--sic-promo-cutout--default--media-bg-blur)
    );
            backdrop-filter:var(
      --sic-promo-cutout--media-bg-blur,
      var(--sic-promo-cutout--default--media-bg-blur)
    );
    width:100%;
    height:100%;
    border-radius:var(--sic-promo-cutout--default--border-radius);
    border-radius:var(
      --sic-promo-cutout--border-radius,
      var(--sic-promo-cutout--default--border-radius)
    );
    overflow:hidden;
  }

.layout-area-media .cutout-image,
  .layout-area-media .cutout-image > div{
    height:100%;
  }

.layout-area-media picture{
    display:flex;
  }

.cutout-image{
  width:calc(50% + calc(var(--cutout-left-offset) * 2));
  position:absolute;
  bottom:0;
  right:0;
  line-height:0;
}

.layout-media-first + .cutout-image{
    left:0;
    right:auto;
  }

.layout-media-first .layout-content-wrapper{
    padding-left:var(--cutout-left-offset);
    padding-right:0;
  }

.layout-stacked{
  display:block;
}

.layout-stacked .layout-content-wrapper{
    aspect-ratio:unset;
    padding-left:0;
    padding-right:0;
  }

.layout-stacked .content-wrapper{
    width:100%;
  }

.layout-stacked .content{
    width:100%;
    padding:var(--sic-promo-cutout--default--content-padding--mobile);
    padding:var(
      --sic-promo-cutout--content-padding--mobile,
      var(--sic-promo-cutout--default--content-padding--mobile)
    );
  }

.layout-stacked .cutout-image-wrapper{
    max-width:none;
  }

.layout-stacked .cutout-image{
    position:relative;
    width:100%;
  }

.layout-stacked .cutout-bg{
    top:var(--sic-promo-cutout--default--top-offset--mobile);
    top:var(
      --sic-promo-cutout--top-offset--mobile,
      var(--sic-promo-cutout--default--top-offset--mobile)
    );
    border-top-left-radius:var(--sic-promo-cutout--default--border-radius);
    border-top-left-radius:var(
      --sic-promo-cutout--border-radius,
      var(--sic-promo-cutout--default--border-radius)
    );
    border-top-right-radius:var(--sic-promo-cutout--default--border-radius);
    border-top-right-radius:var(
      --sic-promo-cutout--border-radius,
      var(--sic-promo-cutout--default--border-radius)
    );
  }

.layout-stacked ::slotted([slot='cta']){
    width:100% !important;
  }

.layout-media-first .promo-image{
    margin-left:0;
  }

@media (min-width: 1920px){
  .promo-wrapper{
    grid-template-columns:1.5fr 1fr;
  }

    .promo-wrapper.layout-media-first{
      grid-template-columns:1fr 1.5fr;
    }
}
`;